import {
  Facet,
  FacetGroup,
  Maybe,
  Place,
  ResidentialPropertyListingConnection,
  ResidentialPropertyListingConnectionEdge,
} from '@unreserved-frontend-v2/api/generated/graphql/types'

export interface PlaceData {
  place?: Maybe<Place>
}

export interface FacetGroupData {
  listingTypes: Facet[]
  residentialTypes: Facet[]
  residentialSubType: Facet[]
  userListingSection: Facet[]
  metroArea?: FacetGroup
  city?: FacetGroup
  region?: FacetGroup
  macroNeighbourhood?: FacetGroup
  subNeighbourhood?: FacetGroup
  neighbourhood?: FacetGroup
  street?: FacetGroup
  tags?: FacetGroup
}

export interface ListingsData extends PlaceData, FacetGroupData {
  totalNumberOfListings: number
  listings: Maybe<Array<Maybe<ResidentialPropertyListingConnectionEdge>>>
}

function getFacetGroup(groupName: string, groups: Maybe<Maybe<FacetGroup>[]> | undefined) {
  if (!groups) {
    return undefined
  }

  return groups.find((group: FacetGroup | null) => {
    return group ? group.name === groupName : false
  }) as FacetGroup
}

function getFacets(groupName: string, groups: Maybe<Maybe<FacetGroup>[]> | undefined) {
  if (!groups) {
    return []
  }

  return getFacetGroup(groupName, groups)?.facets || []
}

export function getListingsPlaceData(places: Maybe<Maybe<Place>[]> | undefined): PlaceData {
  return { place: places?.[0] }
}

export function getListingsFacetsData(facetGroups: Maybe<Maybe<FacetGroup>[]> | undefined): FacetGroupData {
  return {
    listingTypes: getFacets('listingType', facetGroups),
    residentialTypes: getFacets('residentialType', facetGroups),
    residentialSubType: getFacets('residentialSubType', facetGroups),
    userListingSection: getFacets('userListingSection', facetGroups),
    region: getFacetGroup('region', facetGroups),
    metroArea: getFacetGroup('metroArea', facetGroups),
    city: getFacetGroup('city', facetGroups),
    neighbourhood: getFacetGroup('neighbourhood', facetGroups),
    macroNeighbourhood: getFacetGroup('macroNeighbourhood', facetGroups),
    subNeighbourhood: getFacetGroup('subNeighbourhood', facetGroups),
    street: getFacetGroup('street', facetGroups),
    tags: getFacetGroup('tags', facetGroups),
  }
}

export function getListingsData(connection: ResidentialPropertyListingConnection): ListingsData {
  const { pageInfo, edges, facetGroups, places } = connection || {}

  return {
    totalNumberOfListings: pageInfo?.totalEdges ?? 0,
    listings: edges == null ? [] : edges,
    ...getListingsPlaceData(places),
    ...getListingsFacetsData(facetGroups as FacetGroup[]),
  }
}
